const reducer = (state, { type, payload }) => {
	//console.log('reducer:', type, payload);
	// console.log('reducer:'+type);
	switch (type) {
		case "SET_STATE_DATA":
			return {
				...state,
				...payload,
			}

		case "SET_GEO_LOCATION":
			return {
				...state,
				geoLocations: payload,
			}
		case "IN_AREA_LOADING":
			return {
				...state,
				areaLoading: true
			}
		case "LOADED":
			return {
				...state,
				areaLoading: false
			}
		case "SET_AREA_MATCH":
			return {
				...state,
				areaLoading: false,
				areas: payload.areas,
				txtAreaName: payload.txtAreaName
			}
		case "SET_LANE_MATCH":
			return {
				...state,
				areaLoading: false,
				...payload,
			}
		default:
			return state
	}
}

export default reducer;